<div class="card">
  <app-card-title key="project.steps.rfq.invitationPreview.provider.priceList.results" />

  @if (isLoadingState() || this.invitationOfferOverviewsResource.isLoading()) {
    <app-loading />
  } @else {
    @for (item of rowVM(); track item.providerTenantMappingResponse.providerTenantId) {
      <p-panel [toggleable]="true" toggler="header" [collapsed]="true">
        <ng-template #header>
          <div class="flex items-center justify-between w-full">
            <span class="font-bold">
              {{ 'common.prefix.provider' | transloco }}
              {{ item.providerTenantMappingResponse.originalName }}
            </span>

            <div class="flex items-center gap-4 mr-4">
              {{ 'common.total' | transloco }}:
              <span class="font-bold text-xl" [ngClass]="item.totalFeeData.color">
                {{
                  item.totalFeeData.sumFees.grandTotalAllYears
                    | appCurrency: item.totalFeeData : 0 : 0
                }}
              </span>
            </div>
          </div>
        </ng-template>

        <ng-template #headericons let-collapsed>
          <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
        </ng-template>

        <app-step-8-2-3-rfq-preview-price-list
          [invitationOfferOverview]="item.invitationOfferOverviewResponse"
          [isReadOnly]="true"
          (totalFeesCard)="updateTotalFeesCard(item, $event)"
        ></app-step-8-2-3-rfq-preview-price-list>
      </p-panel>
      <br />
    } @empty {
      <app-no-data />
    }
  }
</div>
